export const windowColors = {
  undefined: "#ebd1d1",
  false: "#ebd1d1",
  true: "#d5ebd1",
  arrived: "#f5f2c6",
  installed: "#d5ebd1",
};
